import { render } from "./CardProductComponent.vue?vue&type=template&id=1a18d945&scoped=true"
import script from "./CardProductComponent.vue?vue&type=script&lang=js"
export * from "./CardProductComponent.vue?vue&type=script&lang=js"

import "./CardProductComponent.vue?vue&type=style&index=0&id=1a18d945&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a18d945"]])

export default __exports__